export const educationData = [
    {
        id: 1,
        institution: 'Lucknow University',
        course: 'BS Computer Science',
        startYear: '2009',
        endYear: '2012'
    },
    {
        id: 2,
        institution: 'Jamia Millia islamia',
        course: 'MS Computer Science',
        startYear: '2012',
        endYear: '2015'
    },
]